<template>
  <header>
    <!-- <sui-image src="https://avatars3.githubusercontent.com/u/23255780?s=460&v=4" size="mini" circular id="avatar" /> -->
    <!-- <b-img src="https://avatars3.githubusercontent.com/u/23255780?s=460&v=4" rounded="circle" id="avatar" /> -->
    <div id="title">
      <h1>Github Repos</h1>
      <h3>An index view of Github repos</h3>
    </div>
    <sui-input 
      placeholder="Search..." 
      icon="search"
      id="repo-searchbar" 
      v-model="owner" 
      floating
      @keydown.13="updateOwner"
    />
    <sui-dropdown
      text="Select Type"
      id="owner-type-dropdown"
      button
      class="icon"
      floating
      icon="user"
      labeled
      :options="ownerTypes"
      v-model="ownerType"
    />
    <!-- <b-input-group id="repo-searchbar">
      <b-form-input></b-form-input>
      <b-input-group-append>
        <b-button variant="info"><v-icon name="search"></v-icon></b-button>
      </b-input-group-append>
    </b-input-group> -->
  </header>
</template>

<script>

export default {
  data() {
    return {
      owner: '',
      ownerType: 'org',
      ownerTypes: [
        {key: 'User', text: 'User', value: 'user'},
        {key: 'Organization', text: 'Organization', value: 'org'}
      ]
    }
  },
  methods: {
    async updateOwner() {
      this.$store.dispatch('updateLoadingError', '');
      this.$store.dispatch('updateLoaded', false);
      try {
        await this.$store.dispatch('updateOwner', {owner: this.owner, ownerType: this.ownerType});
      } catch (err) {
        this.$store.dispatch('updateLoadingError', this.ownerType === 'org' ? 'Organization Not Found' : 'User Not Found');
      }
      this.$store.dispatch('updateLoaded', true);
    }
  },
  // mounted() {
  //   document.querySelector('#repo-searchbar i').addEventListener('click', async (e) => {
  //     console.log('haha');
  //     await this.updateOwner();
  //   });
  // }
}
</script>

<style>
header {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
  background-color: #393E46;
}

#avatar {
  position: absolute;
  top: 16px;
  left: 16px;
  height: 48px;
  width: 48px;
}

div#repo-searchbar {
  width: 184px;
  height: 32px;
  position: absolute;
  top: 56px;
  right: 16px;
}

#repo-searchbar input {
  border: none;
}

#repo-searchbar > i {
  background-color: #00ADB5;
  color: white;
  cursor: pointer;
}

#owner-type-dropdown {
  width: 184px;
  height: 32px;
  position: absolute;
  top: 16px;
  right: 16px;
  margin: 0;
  background-color: #00ADB5;
  opacity: 50%;
  color: white;
}

#owner-type-dropdown input {
  height: 32px;
}

#title {
  text-align: center;
}

#title h1 {
  color: #00ADB5;
  font-size: 64px;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
}

#title h3 {
  color: white;
  font-size: 24px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 200;
  margin-top: 8px;
}

@media screen and (max-width: 1024px) {
  header {
    height: 300px;
  }

  #title {
    transform: translate(0, 25px);
  }
}

@media screen and (max-width: 564px) {
  #title h3 {
    font-size: 20px;
  }

  #title h1 {
    font-size: 48px;
  }

  #avatar {
    display: none;
  }

  #owner-type-dropdown {
    top: 0;
    left: 0;
    width: 100%;
    border-radius: 0;
    border: none;
    height: 40px;
  }

  div#repo-searchbar {
    top: 44px;
    left: 0;
    width: 100%;
    height: 40px;
  }

  #repo-searchbar, #repo-searchbar i {
    border-radius: 0;
    border: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SearchPageHeader.vue